import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
/**
 * Returns all (non-section) children from a nested array of content.
 * Useful to determine the total count of content within a section.
 */

export function getAllContentChildren(items) {
  return items.flatMap(function (item) {
    var children = item.children,
      itemWithoutChildren = _objectWithoutProperties(item, _excluded);
    if (item.type === 'section') {
      return getAllContentChildren(children);
    } else {
      // Typecasting was the only way I knew to make TS accept this code. :(
      // It shouldn't be harmful as the outward facing return type is correct
      return [itemWithoutChildren];
    }
  });
}